import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface PieChartIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const PieChartIcon = ({ className, ...props }: PieChartIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 2.25C12.4142 2.25 12.75 2.58579 12.75 3V11.25H21C21.4142 11.25 21.75 11.5858 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25ZM11.25 3.78516C7.04519 4.16414 3.75 7.69651 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.3035 20.25 19.8348 16.9548 20.2139 12.75H12C11.5858 12.75 11.25 12.4142 11.25 12V3.78516ZM14.2598 2.80859C14.4522 2.66743 14.701 2.62579 14.9287 2.69727C17.959 3.65058 20.3501 6.04262 21.3027 9.07324C21.3743 9.30101 21.3336 9.5497 21.1924 9.74219C21.0511 9.93467 20.8257 10.0479 20.5869 10.0479H14.7031C14.5042 10.0478 14.3135 9.96878 14.1729 9.82812C14.0323 9.68747 13.9531 9.49669 13.9531 9.29785L13.9541 3.41309C13.9542 3.1745 14.0675 2.94984 14.2598 2.80859ZM15.4531 8.54785H19.4951C18.6731 6.7665 17.2344 5.32707 15.4531 4.50488V8.54785Z"
      fill="currentColor"
    />
  </svg>
);

export default PieChartIcon;
